import { css } from '@emotion/react';
import fonts from 'Themes/fonts';
import colors from '../../../Themes/colors';

const { black, lightbrown, lighterbrown, lightred } = colors;

export const UserContainer = css({
    paddingBottom: '40px',
});

export const pointsText = css({
    fontSize: '16px',
    paddingLeft: '20px',
    '@media(min-width: 568px)': {
        paddingLeft: '40px',
    },
    '@media(min-width: 1200px)': {
        paddingLeft: '92px',
    },
});

export const UserTitle = css({
    padding: '22px 22px 0px',
    fontSize: '18px',
    fontWeight: 700,
    color: black,
    marginBottom: '20px',
    '@media(min-width: 568px)': {
        padding: '42px 40px 0px',
        fontSize: '25px',
        marginBottom: '50px',
    },
    '@media(min-width: 1200px)': {
        paddingLeft: '92px',
    },
});

export const UserTabTittle = css({
    font: '14px Archivo-Regular, serif',
    color: black,
    padding: '0px 8px',
    '@media(min-width: 768px)': {
        font: '18px Archivo-Regular, serif',
    },
});

export const LogoutTitle = css({
    font: '14px Archivo-Regular, serif',
    color: 'black',
    padding: '0px 8px',
    '@media(min-width: 768px)': {
        fontSize: '18px',
    },
});

export const UserTabStyle = css({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
});
export const LogoutContainer = css({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
});

export const UserTabContainer = css({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '5px',
    '@media(min-width: 870px)': {
        padding: '15px',
    },
});

export const UserTabList = css({
    listStyleType: 'none',
    padding: '0px',
    margin: '0px',
});

export const IconStyle = css({
    '@media(min-width: 300px)': {
        width: 35,
        height: 35,
    },

    '@media(min-width: 575px)': {
        width: 20,
        height: 20,
    },
    '@media(min-width: 1200px)': {
        width: 35,
        height: 35,
    },
});

export const UserTabSelected = css({
    justifyContent: 'center',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    background: lightbrown,
    padding: '20px',
    borderRadius: '20px',
    margin: '10px 0px',
    cursor: 'pointer',
    '@media(min-width: 575px)': {
        padding: '11px 0px 11px 10px',
        justifyContent: 'start',
        width: 'clamp(40px,80%,180px)',
    },
    '@media(min-width: 870px)': {
        padding: '11px 10px 11px 20px',
        width: '240px',
    },
});

export const UserTab = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    borderRadius: '20px',
    margin: '10px 0px',
    cursor: 'pointer',

    '&:hover': { background: lighterbrown, borderRadius: '18px' },

    '@media(min-width: 575px)': {
        padding: '11px 0px 11px 10px',
        justifyContent: 'start',
        width: 'clamp(40px,80%,180px)',
    },
    '@media(min-width: 870px)': {
        padding: '11px 10px 11px 20px',
        width: '240px',
    },
});

export const UserTabRowCointainer = css({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    width: '100%',
});

export const WishTitle = css({
    fontSize: '2rem',
    fontWeight: 700,
    color: 'black',
    letterSpacing: 0.6,
    transform: 'scale(1, 0.9)',
});

export const SubTitle = css({
    font: '18px Archivo-Regular, serif',
    color: black,
});

export const WishlistEmpty = css({
    fontSize: '1.2rem',
    fontFamily: 'AcuminRPro',
    color: black,
    marginTop: 20,
});

export const WishProductGrid = css({
    display: 'grid',
    gridTemplateColumns: '1fr',

    '@media(min-width: 880px)': {
        gridTemplateColumns: '1fr 1fr 1fr',
    },
    '@media(min-width: 1200px)': {
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },
    padding: '10px',
});

export const WishProduct = css({
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
});

export const FilterContainer = css({
    display: 'flex',
    alignItems: 'center',
});

export const OptionsContainer = css({
    display: 'flex',
    justifyContent: 'space-between',
});

export const TabMobileView = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
});
